/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ManagerProfile,
  ManagerProfileRequest,
  PatchedManagerProfileRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getManagerProfilesCreateUrl = () => {




  return `/api/manager-profiles/`
}

/**
 * Apply this mixin to any view or viewset to perform the "market not listed" flow.
 *
 * It needs a CharField " market_not_listed_name " declared in the main serializer of the View or Viewset.
 * Also the main serializer should use some of the custom market Validator classes.
 */
export const managerProfilesCreate = async (managerProfileRequest?: ManagerProfileRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagerProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerProfile>(getManagerProfilesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managerProfileRequest)
  }
);}





export const getManagerProfilesCreateMutationKey = () => ['managerProfilesCreate'] as const;

export const getManagerProfilesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerProfilesCreate>>, TError,ManagerProfilesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managerProfilesCreate>>, TError,ManagerProfilesCreateMutationVariables, TContext> => {

const mutationKey = getManagerProfilesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managerProfilesCreate>>, ManagerProfilesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  managerProfilesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagerProfilesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof managerProfilesCreate>>>
    export type ManagerProfilesCreateMutationBody = ManagerProfileRequest | undefined
    export type ManagerProfilesCreateMutationError = void
    export type ManagerProfilesCreateMutationVariables = {data?: ManagerProfileRequest}

    export const useManagerProfilesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerProfilesCreate>>, TError,ManagerProfilesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof managerProfilesCreate>>,
        TError,
        ManagerProfilesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getManagerProfilesCreateMutationOptions(options), queryClient);
    }
    export const getManagerProfilesRetrieveUrl = (id: number | 'me',) => {




  return `/api/manager-profiles/${id}/`
}

/**
 * Apply this mixin to any view or viewset to perform the "market not listed" flow.
 *
 * It needs a CharField " market_not_listed_name " declared in the main serializer of the View or Viewset.
 * Also the main serializer should use some of the custom market Validator classes.
 */
export const managerProfilesRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<ManagerProfile> => {

  return customFetch<ManagerProfile>(getManagerProfilesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getManagerProfilesRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/manager-profiles/${id}/`
    ] as const;
    }


export const getManagerProfilesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getManagerProfilesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof managerProfilesRetrieve>>> = ({ signal }) => managerProfilesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ManagerProfilesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof managerProfilesRetrieve>>>
export type ManagerProfilesRetrieveQueryError = void


export function useManagerProfilesRetrieve<TData = Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof managerProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof managerProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useManagerProfilesRetrieve<TData = Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof managerProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof managerProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useManagerProfilesRetrieve<TData = Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useManagerProfilesRetrieve<TData = Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof managerProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getManagerProfilesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getManagerProfilesUpdateUrl = (id: number | 'me',) => {




  return `/api/manager-profiles/${id}/`
}

/**
 * Apply this mixin to any view or viewset to perform the "market not listed" flow.
 *
 * It needs a CharField " market_not_listed_name " declared in the main serializer of the View or Viewset.
 * Also the main serializer should use some of the custom market Validator classes.
 */
export const managerProfilesUpdate = async (id: number | 'me',
    managerProfileRequest?: ManagerProfileRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagerProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerProfile>(getManagerProfilesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managerProfileRequest)
  }
);}





export const getManagerProfilesUpdateMutationKey = () => ['managerProfilesUpdate'] as const;

export const getManagerProfilesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerProfilesUpdate>>, TError,ManagerProfilesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managerProfilesUpdate>>, TError,ManagerProfilesUpdateMutationVariables, TContext> => {

const mutationKey = getManagerProfilesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managerProfilesUpdate>>, ManagerProfilesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  managerProfilesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagerProfilesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof managerProfilesUpdate>>>
    export type ManagerProfilesUpdateMutationBody = ManagerProfileRequest | undefined
    export type ManagerProfilesUpdateMutationError = void
    export type ManagerProfilesUpdateMutationVariables = {id: number | 'me';data?: ManagerProfileRequest}

    export const useManagerProfilesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerProfilesUpdate>>, TError,ManagerProfilesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof managerProfilesUpdate>>,
        TError,
        ManagerProfilesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getManagerProfilesUpdateMutationOptions(options), queryClient);
    }
    export const getManagerProfilesPartialUpdateUrl = (id: number | 'me',) => {




  return `/api/manager-profiles/${id}/`
}

/**
 * Apply this mixin to any view or viewset to perform the "market not listed" flow.
 *
 * It needs a CharField " market_not_listed_name " declared in the main serializer of the View or Viewset.
 * Also the main serializer should use some of the custom market Validator classes.
 */
export const managerProfilesPartialUpdate = async (id: number | 'me',
    patchedManagerProfileRequest?: PatchedManagerProfileRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagerProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerProfile>(getManagerProfilesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedManagerProfileRequest)
  }
);}





export const getManagerProfilesPartialUpdateMutationKey = () => ['managerProfilesPartialUpdate'] as const;

export const getManagerProfilesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerProfilesPartialUpdate>>, TError,ManagerProfilesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof managerProfilesPartialUpdate>>, TError,ManagerProfilesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getManagerProfilesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof managerProfilesPartialUpdate>>, ManagerProfilesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  managerProfilesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ManagerProfilesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof managerProfilesPartialUpdate>>>
    export type ManagerProfilesPartialUpdateMutationBody = PatchedManagerProfileRequest | undefined
    export type ManagerProfilesPartialUpdateMutationError = void
    export type ManagerProfilesPartialUpdateMutationVariables = {id: number | 'me';data?: PatchedManagerProfileRequest}

    export const useManagerProfilesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof managerProfilesPartialUpdate>>, TError,ManagerProfilesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof managerProfilesPartialUpdate>>,
        TError,
        ManagerProfilesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getManagerProfilesPartialUpdateMutationOptions(options), queryClient);
    }
